<template>
    <el-tabs v-model="currentTab" @tab-click="onTabChange" type="border-card" class="tabs">
        <el-tab-pane v-for="tab in tabs" :key="tab.name" :label="tab.name.toUpperCase()" :name="tab.name">
            <component :is="tab" />
        </el-tab-pane>
    </el-tabs>
</template>

<script>
export default {
    data() {
        return { currentTab: '' };
    },
    props: {
        activeTab: String,
        // tabs is an array of Vue Components.
        // define names for the components in that array.
        tabs: Array,
        onTabChange: {
            type: Function,
            default: () => {}
        },
    },
    created() {
        this.currentTab = this.activeTab;
    },
    watch: {
        activeTab(newTab) {
            this.currentTab = newTab;
        }
    }
}
</script>

<style scoped>
.tabs {
    height: 90%;
}
.tab-title {
    text-transform: capitalize;
}
</style>
